import { Component, OnInit, Input, NgZone, Renderer2, RendererStyleFlags2, ViewChild, ElementRef } from '@angular/core';
import { DomController, ModalController, Platform } from '@ionic/angular';
import { MaintenanceComponent } from '../modals/menu/maintenance/maintenance.component';
import { GlobalMethodsService } from 'src/app/services/global-methods.service';
import { HistoricalComponent } from '../modals/menu/historical/historical.component';
import { MoreComponent } from '../modals/menu/more/more.component';
import { ProtocolComponent } from '../modals/menu/protocol/protocol.component';
import { NavigationService } from '../../services/commons/navigation.service';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { ModalService } from '../../services/commons/modal.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/commons/auth.service';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { LocationService } from '../../services/Location/location.service';
import { StorageService } from '../../services/commons/storage.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  public openDropdown: boolean = false;
  public pressAlarm: boolean;
  public counter?: number = 3;
  private timeout: any;
  @Input('alarmActivated') alarmActivated: boolean = false; // Home alarm activated -> alarmActivated = true | Home default -> alarmActivated = false
  public maintenancePressed = false;
  public historicalPressed = false;
  public morePressed = false;
  public protocolPressed = false;
  public showNotificationPanel: boolean = true;
  private touchHeight: number;
  public moreComponentEvent: Subscription;
  public touchMove: boolean;
  public isMobile = true;
  public newTop: number = -78;
  public pendingMessages = 0;

  @ViewChild('notificationPanel') tracking: ElementRef;

  constructor(private zone: NgZone,
    private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    public gvs: GlobalVariablesService,
    private translate: TranslateConfigService,
    public navigation: NavigationService,
    private platform: Platform,
    private domCtrl: DomController,
    private storage: StorageService,
    private renderer: Renderer2,
    public locationService: LocationService,
    public modalService: ModalService,
    public authService: AuthService,
    private openNativeSettings: OpenNativeSettings,
    private router: Router) {
    this.gms.setupPageEvent().subscribe((setupPage) => {
      this.zone.run(async () => {
        this.showNotificationPanel = setupPage.showNotificationPanel;
        this.openDropdown = false;
      });
    });

    this.gms.openMaintenanceCall$.subscribe(async reception => {
      if (await this.authService.ifAuthLoggedIn()) {
        await this.navigation.goHome();
        this.openMaintenanceModal(reception);
      }
    });

    this.gms.openHistoricalCall$.subscribe(async reception => {
      if (await this.authService.ifAuthLoggedIn()) {
        await this.navigation.goHome();
        this.openHistoricalModal(reception);
      }
    });

    this.gms.footerChatNotifCall$.subscribe(async reception => {
      if (reception > 0){
        this.pendingMessages = this.pendingMessages + reception;
        } else {
          this.pendingMessages = 0;
        }
    });

    this.isMobile = this.platform.is("mobile") ? true : false;
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.moreComponentEvent = this.gms.statusMoreComponentEvent().subscribe(async (value: boolean) => {
      this.zone.run(async () => {
        if (!value) {
          this.morePressed = false;
        }
        this.showNotificationPanel = value;
      });
    });
  }

  ngOnDestroy() {
    this.moreComponentEvent.unsubscribe()
  }

  slideUpDown() {
    if (this.openDropdown) {
      this.openDropdown = false;
    } else {
      this.openDropdown = true;
    }
  }

  startAlarm() {
    this.zone.run(() => {
      this.pressAlarm = true;
      this.counter = 3;
    });
    this.gms.analyticsTrackEvent('footer', { eventCategory: 'SICOR/Notificar Emergencia', eventAction: 'Accion/Notificar Emergencia Click' });
    this.countdown();
  }

  stopAlarm() {
    this.zone.run(() => {
      this.pressAlarm = false;
      if (this.timeout) {
        clearInterval(this.timeout);
      }
      this.counter = 3;
      this.gms.analyticsTrackEvent('footer', { eventCategory: 'SICOR/Notificar Emergencia', eventAction: 'Accion/Notificar Emergencia Parar' });
    });
  }

  async countdown() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    this.timeout = setTimeout(async () => {
      if (this.pressAlarm && this.counter && this.counter > 1) {
        this.zone.run(() => {
          this.counter--;
        });
        if (await this.platform.is('cordova')) {
          this.gms.hapticsImpact();
        }
        this.countdown();
      } else {
        this.stopAlarm();
        await this.navigation.goTo("/alarm?screen=home");
      }
    }, 1000);
  }

  async closeOptions() {
    // if (this.maintenancePressed || this.historicalPressed || this.morePressed || this.protocolPressed) {
    if (this.gvs.modalLoaded != 'empty') {

      this.modalService.closeAllOpenModals();

      this.maintenancePressed = false;
      this.historicalPressed = false;
      this.protocolPressed = false;
      this.morePressed = false;
    }
  }


  // Default modal
  async openMaintenanceModal(data?) {
    if (!this.modalService.isOpeningModal) {
      if (!this.maintenancePressed) {
        if (this.gvs.modalLoaded === 'empty') {
          this.gvs.modalLoaded = 'maintenance';
        }
        else {
          return;
        }
        if (this.gvs.modalLoaded !== 'maintenance') {
          return;
        }
        await this.closeOptions();

        this.maintenancePressed = true;
        const contentModal = await this.modalService.show(MaintenanceComponent, "maintenanceModal", {data}, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal'])

        contentModal.onDidDismiss().then(response => {
          if (this.router.url.includes('/home')){
            this.gms.setMoreComponentEvent(true);
          }
          if (response.data === null) {
            return;
          }
          this.zone.run(async () => {
            await this.gms.startIntervalSatusInstallationEvent();
            this.maintenancePressed = false;
          });
        });

      } else {
        this.modalService.hide("maintenanceModal");
      }
    }
  }

  // Default modal
  async openHistoricalModal(data?) {
    if (!this.modalService.isOpeningModal) {
      if (!this.historicalPressed) {
        if (this.gvs.modalLoaded === 'empty') {
          this.gvs.modalLoaded = 'historical';
        }
        else {
          return;
        }
        if (this.gvs.modalLoaded !== 'historical') {
          return;
        }
        await this.closeOptions();

        this.historicalPressed = true;
        const contentModal = await this.modalService.show(HistoricalComponent, "historicalModal", { data }, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal'])

        contentModal.onDidDismiss().then(response => {
          if (this.router.url.includes('/home')){
            this.gms.setMoreComponentEvent(true);
          }
          this.zone.run(async () => {
            await this.gms.startIntervalSatusInstallationEvent();
            this.historicalPressed = false;
          });
        });

      } else {
        this.modalService.hide("historicalModal");
      }
    }
  }

  // Default modal
  async openMoreModal() {
    if (!this.morePressed) {
      await this.closeOptions();
      this.morePressed = true;
      const contentModal = await this.modalCtrl.create({
        component: MoreComponent,
        componentProps: {},
        cssClass: ['modal-default', 'main-menu-modal', 'more-menu'],
        backdropDismiss: true,
        showBackdrop: true
      });

      contentModal.onDidDismiss().then(res => {
        this.zone.run(() => {
          if (res.data != null && res.data.result != null && res.data.result) {
            this.morePressed = false;
          }
        });
      });

      contentModal.present().then();
    } else {
      this.morePressed = false;
      this.modalCtrl.dismiss({ result: false });
    }
  }

  async slideMoreModal() {
    if (this.morePressed) {
      this.morePressed = false;
    } else {
      // await this.closeOptions();
      await this.locationService.checkGeofenceProblems();
      this.morePressed = true;
    }

  }

  async slideDownMoreModal() {
    this.morePressed = false;
  }

  // Default modal
  async openProtocolModal() {
    if (!this.modalService.isOpeningModal) {
      if (!this.protocolPressed) {
        if (this.gvs.modalLoaded === 'empty') {
          this.gvs.modalLoaded = 'protocol';
        }
        else {
          return;
        }
        if (this.gvs.modalLoaded !== 'protocol') {
          return;
        }
        await this.closeOptions();
        this.protocolPressed = true;
        const contentModal = await this.modalService.show(ProtocolComponent, "protocolModal", {}, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal'])

        contentModal.onDidDismiss().then(response => {
          if (this.router.url.includes('/home')){
            this.gms.setMoreComponentEvent(true);
          }
          if (response.data === null) {
            return;
          }
          this.zone.run(async () => {
            await this.gms.startIntervalSatusInstallationEvent();
            this.protocolPressed = false;
          });
        });
      } else {
        this.modalService.hide("protocolModal");
      }
    }
  }

  async checkExpirationAuth() {
    const expirationAuth: boolean = await this.gms.checkExpirationAuth();
    if (!expirationAuth) {
      const result = await this.gms.getCheckBiometricAuth((await this.authService.getUserLogin(this.gvs.user)).activeBiometric);
      if (result) {
        await this.authService.setExpirationAuth();
        await this.openProtocolModal();
      } else {
        this.protocolPressed = false;
        // this.modalService.hide("protocolModal");
        this.closeOptions();
        return;
      }
    } else {
      await this.openProtocolModal();
    }
  }

  touch(event: any) {
    if (event.type === 'touchmove') {
      this.touchMove = true;
      if (this.touchHeight > event.changedTouches[0].clientY) {
        this.touchUp(event);
      } else {
        this.touchDown(event);
      }
    } else {
      return;
    }
  }

  touchUp(event) {
    this.touchHeight = event.changedTouches[0].clientY;
    this.newTop = (this.touchHeight - this.tracking.nativeElement.getBoundingClientRect().top) + (this.tracking.nativeElement.offsetTop);
    if ((this.newTop < -120 && this.newTop >= -286) || this.newTop < -286) {
      this.newTop = -286;
    }

    this.domCtrl.write(() => {
      this.renderer.setStyle(this.tracking.nativeElement, 'top', this.newTop + 'px', RendererStyleFlags2.Important);
    });
  }

  touchDown(event) {
    this.touchHeight = event.changedTouches[0].clientY;
    this.newTop = (this.touchHeight - this.tracking.nativeElement.getBoundingClientRect().top) - (- this.tracking.nativeElement.offsetTop);
    if ((this.newTop > -220 && this.newTop <= -78) || this.newTop > -78) {
      this.newTop = -78;
    }
    this.domCtrl.write(() => {
      this.renderer.setStyle(this.tracking.nativeElement, 'top', this.newTop + 'px', RendererStyleFlags2.Important);
    });
  }

  touchEnd(event: any) {
    if (event.type === 'touchend' && this.touchMove) {
      if ((this.newTop < -120 && this.newTop >= -286) || this.newTop < -286) {
        this.openDropdown = true;
        this.touchHeight = undefined
      }
      if ((this.newTop > -220 && this.newTop <= -78) || this.newTop > -78) {
        this.openDropdown = false;
        this.touchHeight = 0;
      }
      this.touchMove = false;
    }
    else {
      if (event.srcElement.className === 'scr--icon icon-up' || event.srcElement.className === 'scr--icon icon-down') {
        this.renderer.setStyle(this.tracking.nativeElement, 'top', 'initial', RendererStyleFlags2.Important);
        this.slideUpDown();
        return;
      } else {
        return;
      }
    }
  }
}
